import { piiSharingConstants } from 'pages/integrations/containers/LtiIntegrationContainer/piiSharing/constants';

const piiSharingConfigsInitialState = {
  isLoading: false,
  piiSharingConfigs: []
};

const updateConfigEnabled = (configs, courseId, enabled) =>
  configs.map((config) => (config.course_id === courseId ? { ...config, enabled } : config));

export const fetchPiiSharingConfigs = (state = piiSharingConfigsInitialState, action) => {
  switch (action.type) {
    case piiSharingConstants.FETCH_PII_SHARING_CONFIGS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case piiSharingConstants.FETCH_PII_SHARING_CONFIGS_SUCCESS:
      return {
        ...state,
        piiSharingConfigs: action.payload,
        isLoading: false
      };
    case piiSharingConstants.FETCH_PII_SHARING_CONFIGS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      };
    case piiSharingConstants.UPDATE_PII_SHARING_CONFIG_SUCCESS:
      return {
        ...state,
        piiSharingConfigs: updateConfigEnabled(state.piiSharingConfigs, action.payload.courseId, action.payload.enabled)
      };
    case piiSharingConstants.UPDATE_PII_SHARING_CONFIG_FAILURE:
      return {
        ...state,
        piiSharingConfigs: updateConfigEnabled(state.piiSharingConfigs, action.payload.courseId, action.payload.enabled)
      };
    default:
      return state;
  }
};
